import {
  DELETE_VP_FAILED,
  DELETE_VP_SUCCESS,
  DELETE_VP_INVALID_REQUEST,
  DELETE_VP_NOT_FOUND,
  LOADING_DELETE_VP,
  RESET_DELETE_VP,
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
  status: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_DELETE_VP:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        invalidRequest: false,
        notFound: false,
        status: "",
      };

    case DELETE_VP_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        invalidRequest: false,
        notFound: false,
        status: "Failed to delete product, please try again!",
      };

    case DELETE_VP_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        notFound: false,
        status: "Something went wrong!",
      };

    case DELETE_VP_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        success: true,
        invalidRequest: false,
        failed: false,
        notFound: false,
        products: action.payload,
        status: "Product deleted successfully!",
      };
    }

    case DELETE_VP_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        notFound: true,
        status: "Delete product not found!",
      };

    case RESET_DELETE_VP:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        notFound: false,
        status: "",
      };

    default:
      return state;
  }
};
